// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__25XEs","buttons":"RemoveExpirationActionButtons_buttons__ZUqCX"};